import { render, staticRenderFns } from "./more.vue?vue&type=template&id=58b737d7&scoped=true&"
import script from "./more.vue?vue&type=script&lang=ts&"
export * from "./more.vue?vue&type=script&lang=ts&"
import style0 from "./more.vue?vue&type=style&index=0&id=58b737d7&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b737d7",
  null
  
)

export default component.exports